import logo from '../assets/images/2.png';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const navigate = useNavigate();
    return (
        <div className="header">
           <img src={logo} className='logoHeader' onClick={() => navigate('/')}/>
        </div>
    )
}

export default Navbar;